import { Box, IconButton, Tooltip } from "@mui/material";
import FilterListIcon from '@mui/icons-material/FilterList';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import { useState } from "react";
import { isArray } from "lodash";
import { useTranslation } from "react-i18next";

const TOOL_TIP_OPEN = "toolTipFilterContainerOpen";
const TOOL_TIP_CLOSE = "toolTipFilterContainerClose";
const FilterContainer = props => {
  const { t } = useTranslation();
  const { sx, children, hasIcons = true } = props;
  const [filterCollapsed, setFilterCollapsed] = useState(false);

  const collapseFilter = _event => {
    setFilterCollapsed(!filterCollapsed);
  };

  let arrayChildren = hasIcons ? [children] : [children, null];
  if (isArray(children)) {
    arrayChildren = hasIcons ? children : [...children, null];
  }
  const lastIndex = arrayChildren?.length - 1;

  const defaultStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "right",
  };

  return (
    <>
      <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", rowGap: 1, width: "100%", pt: 1, pb: 1, ...sx }}>
        {arrayChildren?.map((child, index) => {
          const stringIndex = String(index);

          if (index === lastIndex) {
            return (
              <Box 
                key={`filter-${stringIndex}`}
                sx={{ float: "right", ml: "auto", ...defaultStyle }}
                >
                {child}
                <Box sx={{ ml: "auto", ...defaultStyle, alignItems: "center" }}>
                  <Tooltip placement="bottom-start" title={filterCollapsed ? t(TOOL_TIP_OPEN) : t(TOOL_TIP_CLOSE)}>
                    <IconButton
                      color="info"
                      size="small"
                      onClick={collapseFilter}>
                      {filterCollapsed ? <FilterListIcon /> : <FilterListOffIcon />}
                    </IconButton>
                  </Tooltip>
                </Box>
              </Box>
            );
          }
          return (
            <Box
              sx={{ display: filterCollapsed ? "none" : "block", flex: "0 0 auto" }}
              key={`filter-${stringIndex}`}
              className={"wrap-filters"}
            >
              {child}
            </Box>
          );
        })}
      </Box>
    </>
  );
};

export default FilterContainer;
